<template>
  <div id="app">
    <router-view class="view" v-if="isRouterAlive" />
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide() { // 提供reload方法
      return {
        reload: this.reload,
        deepClone: this.deepClone
      }
    },
    data() {
      return {
        isRouterAlive: true
      }
    },
    mounted() {
      function checkIE() {
        return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
      }
      if (checkIE()) {
        window.addEventListener('hashchange', () => {
          var currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        }, false)
      }
      const script = document.createElement('script')
      script.src = 'https://s9.cnzz.com/z_stat.php?id=1278741675&web_id=1278741675'
      script.language = 'JavaScript'
      document.body.appendChild(script)
    },
    watch: {

      '$route': function(to, from) {
        document.body.scrollTop = 0

        document.documentElement.scrollTop = 0

        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
      }
    },
    components: {},

    methods: {
      _isMobile() { // 判断移动端
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag
      },
      reload() {
        this.isRouterAlive = false
        this.$nextTick(function() {
          this.isRouterAlive = true
        })
      },

      // 定义一个深拷贝函数  接收目标target参数
      deepClone(target) {
        // 定义一个变量
        let result
        // 如果当前需要深拷贝的是一个对象的话
        if (typeof target === 'object') {
          // 如果是一个数组的话
          if (Array.isArray(target)) {
            result = [] // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
              // 递归克隆数组中的每一项
              result.push(this.deepClone(target[i]))
            }
            // 判断如果当前的值是null的话；直接赋值为null
          } else if (target === null) {
            result = null
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
          } else if (target.constructor === RegExp) {
            result = target
          } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {}
            for (let i in target) {
              result[i] = this.deepClone(target[i])
            }
          }
          // 如果不是对象的话，就是基本数据类型，那么直接赋值
        } else {
          result = target
        }
        // 返回最终结果
        return result
      }
    }
  }
</script>

<style>
  /* @import "../static/css/main.css";
@import "../static/css/color-dark.css";     深色主题 */

  /*ul,li{*/
  /*  padding: 0;*/
  /*  margin: 0;*/
  /*  list-style: none;*/
  /*}*/
  #app {
    height: 100%;
    /* background-color: #004C9A; */
    font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
    /* background: #EAE9E9; */
    background: #fff;
    font-size: 12px;
    color: #333;
  }

  .page-content {
    max-width: 1230px;
    min-width: 1230px;
    margin: 0 auto;
    padding: 12px 0;
    overflow: hidden;
    background: #fff;
  }

  .flex {
    display: flex !important;
  }

  .flex-1 {
    flex: 1 !important;
  }

  .relative {
    position: relative !important;
  }

  .ml-20 {
    margin-left: 20px !important;
  }

  .w-full {
    width: 100% !important;
  }

  .about-wrapper {
    flex: 1 !important;
    margin-left: 20px !important;
  }

  .page-content {
    display: flex;
  }

  .block {
    display: block !important;
  }
</style>



// WEBPACK FOOTER //
// src/app.vue